import * as $ from 'jquery';
import 'datatables';

export default (function () {
  $('#dataTable').DataTable({
		"lengthMenu": [[100, 200, 500, -1], [100, 200, 500, "All"]],
		language: {
			'url' : 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
			// More languages : http://www.datatables.net/plug-ins/i18n/
		},
		aaSorting: [],
		"autoWidth": false
	});
}());
